import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  PaymentMethod,
  PaymentMethodType,
} from '../../../../../../../../data/dietitian/domain/subscription/payment_method';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-payment-informations-edit',
  templateUrl: './payment-informations-edit.component.html',
  styleUrls: ['./payment-informations-edit.component.scss'],
})
export class PaymentInformationsEditComponent {
  @Input() paymentMethod: PaymentMethod | undefined;
  @Input() loading = false;
  @Input() withModifyButton: boolean;
  @Output() modify = new EventEmitter<void>();
  @Output() default = new EventEmitter<void>();

  public get isCard() {
    return (
      this.paymentMethod && this.paymentMethod.type == PaymentMethodType.Card
    );
  }

  modifyPaymentInformation() {
    this.modify?.emit();
  }

  getExpiration(): string {
    if (this.paymentMethod?.expMonth && this.paymentMethod?.expYear) {
      return (
        ' (exp. ' +
        (this.paymentMethod?.expMonth < 10
          ? '0' + this.paymentMethod?.expMonth
          : this.paymentMethod?.expMonth) +
        '/' +
        this.paymentMethod?.expYear.toString().substring(2) +
        ')'
      );
    }
    return '';
  }

  defaultPaymentInformation() {
    this.default?.emit();
  }
}
